/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  Stack,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';

// Visualização do ponto GPS ao clicar no marker do mapa. Read-only — usuário
// vê os dados e clica em "Editar" pra abrir o form completo (PointUpdateWindow).
// Evita entrar direto em modo edição toda vez que se clica no pino.
export default function PointViewWindow({ point, onEdit, onClose }) {
  if (!point) return null;

  return (
    <Box sx={{ width: 280, py: 0.5 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 0.75 }}>
        {point.name}
      </Typography>

      <Stack direction="row" spacing={0.75} sx={{ mb: 1, flexWrap: 'wrap' }}>
        {point.category ? (
          <Chip
            label={point.category}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ height: 22, fontSize: 11 }}
          />
        ) : null}
        <Chip
          label={point.isVisible ? 'Visível' : 'Oculto'}
          size="small"
          color={point.isVisible ? 'success' : 'default'}
          variant="outlined"
          sx={{ height: 22, fontSize: 11 }}
        />
        <Chip
          label={`Raio ${point.radius}m`}
          size="small"
          variant="outlined"
          sx={{ height: 22, fontSize: 11 }}
        />
      </Stack>

      {point.description ? (
        <Typography sx={{ color: '#555', fontSize: 13, mb: 1 }}>
          {point.description}
        </Typography>
      ) : null}

      <Typography
        sx={{
          fontFamily: 'monospace',
          fontSize: 11,
          color: '#888',
          mb: 1.25,
        }}
      >
        {`${Number(point.latitude).toFixed(6)}, ${Number(point.longitude).toFixed(6)}`}
      </Typography>

      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button size="small" onClick={onClose}>
          Fechar
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          startIcon={<EditIcon fontSize="small" />}
          onClick={onEdit}
        >
          Editar
        </Button>
      </Stack>
    </Box>
  );
}

PointViewWindow.propTypes = {
  point: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    category: PropTypes.string,
    description: PropTypes.string,
    latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isVisible: PropTypes.bool,
  }),
  onEdit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
